import summaryTemplate from './summary.template.html';

/*****************************************************************************
 * Component: summary */
/**
 * @ngdoc     component
 * @module    csm.books.fundraisers
 * @name      csm.books.fundraisers.component:summary
 * @description
 * Component definition object for {@link summary}
 *****************************************************************************/
export const summaryContentComponent = {
  require: { dialogCtrl: '^^fundraiserItemsDialog' },
  template: summaryTemplate,
  controller: function () {}
}
